import React from 'react';
import { LegalDocument } from '../components/web/static-page/legal-document';
import document from '../content/legal/marketing.json';
import { withAuth } from '../models/functions/with-auth';
import { getPricingOfferServerSideProps } from '../models/functions/pricing-offer';

const LegalPage: React.FC = () => <LegalDocument document={document} />;

export default withAuth(LegalPage, false);

export const getServerSideProps = getPricingOfferServerSideProps;
